import MyHeader from './sys/my-header/index';
import MyFooter from './sys/my-footer';

export default{
    install: function(Vue){
        Vue.component('my-header', MyHeader);
        Vue.component('my-footer', MyFooter);
    }
}
